module.exports = __webpack_public_path__ + "img/status_gj_icon.23195ca0.png";